<div class="tt-c-comment">
  <div class="tt-c-comment__quote-col">
    <tt-icon name="quote" class="tt-c-comment__quote"></tt-icon>
  </div>
  <div class="tt-c-comment__body tt-u-spacing--xs">
    <p class="tt-c-comment__text">
      <span v-if="prefixText" class="tt-c-comment__comment-prefix" v-html="prefixText"></span> {{commentText}}<template v-if="isTruncated">&hellip;</template>
      <tt-button v-if="isTruncated" type="link" class="tt-c-comment__expand" @click.prevent="expandComment" v-html="$msg('comment.readMore')"></tt-button>
    </p>
    <span v-if="showCatItem" class="tt-c-comment__item" v-html="$msg('comment.aboutItem', [comment.catItem.title])"></span>
    <div v-else class="tt-o-byline tt-c-comment__byline tt-u-spacing--left--xs">
      <tt-button v-if="linkUsername" @click="showProfile" class="tt-o-byline__author tt-o-byline__item" type="link">{{formatUserName(comment.user)}}</tt-button>
      <span v-else class="tt-o-byline__author tt-o-byline__item">{{formatUserName(comment.user)}}</span>
      <span class="tt-o-byline__dot"></span>
      <time :datetime="datetime" class="tt-o-byline__on-date tt-o-byline__item" v-html="dateText"></time>
    </div>
  </div>
</div>
